import * as actionTypes from '../actions/indicators';

const initialState = {
  list: [],
  loaded: false,
  fetching: false
};

const indicatorReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_INDICATORS_SUCCESS:
      return {
        ...state,
        list: action.payload,
        fetching: false,
        loaded: true
      };
    case actionTypes.GET_INDICATORS_FAILURE:
      return {
        ...state,
        fetching: false
      };
    default: {
      return state;
    }
  }
};

export default indicatorReducer;
